export default __webpack_public_path__ + "static/media/quotation-donate.2c117084.png";